// action enums
export enum ActionsEnum {
  SET_DEVICE_ID = 'SET_DEVICE_ID',
  SET_COOKIE = 'SET_COOKIE',
  SET_COOKIES = 'SET_COOKIES',
  REMOVE_COOKIES = 'REMOVE_COOKIES',
  SET_LOCAL_STORAGE_ITEM = 'SET_LOCAL_STORAGE_ITEM',
  REMOVE_LOCAL_STORAGE_ITEM = 'REMOVE_LOCAL_STORAGE_ITEM',
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  TAB_VISIBLE = 'TAB_VISIBLE',
  TAB_HIDDEN = 'TAB_HIDDEN',
}

// action payload interfaces
export interface IKey {
  key: string;
}

export interface IRemoveCookie {
  keys: string[];
  domain: string;
  path: string;
}

export interface IKeyValue extends IKey {
  value: string | number | boolean;
}

export interface IDeviceId {
  deviceId: string;
}

export interface ICookies {
  cookies: IKeyValue[];
}

// action definitions
export interface SetDeviceId {
  type: ActionsEnum.SET_DEVICE_ID;
  payload: IDeviceId;
}

export interface SetCookie {
  type: ActionsEnum.SET_COOKIE;
  payload: IKeyValue;
}

export interface SetCookies {
  type: ActionsEnum.SET_COOKIES;
  payload: ICookies;
}

export interface RemoveCookies {
  type: ActionsEnum.REMOVE_COOKIES;
  payload: IRemoveCookie;
}

export interface SetLocalStorageItem {
  type: ActionsEnum.SET_LOCAL_STORAGE_ITEM;
  payload: IKeyValue;
}

export interface RemoveLocalStorageItem {
  type: ActionsEnum.REMOVE_LOCAL_STORAGE_ITEM;
  payload: IKey;
}

export interface Online {
  type: ActionsEnum.ONLINE;
}

export interface Offline {
  type: ActionsEnum.OFFLINE;
}

export interface TabVisible {
  type: ActionsEnum.TAB_VISIBLE;
}

export interface TabHidden {
  type: ActionsEnum.TAB_HIDDEN;
}

// action creators
export const setDeviceId = (deviceId: string): SetDeviceId => ({
  type: ActionsEnum.SET_DEVICE_ID,
  payload: {
    deviceId,
  },
});

export const setCookie = (key: string, value: string): SetCookie => ({
  type: ActionsEnum.SET_COOKIE,
  payload: {
    key,
    value,
  },
});

export const setCookies = (cookies: IKeyValue[]): SetCookies => ({
  type: ActionsEnum.SET_COOKIES,
  payload: {
    cookies,
  },
});

export const removeCookies = (
  keys: string[],
  path?: string,
  domain?: string
): RemoveCookies => ({
  type: ActionsEnum.REMOVE_COOKIES,
  payload: {
    keys,
    path,
    domain,
  },
});

export const setLocalStorageItem = (
  key: string,
  value: string | number | boolean
): SetLocalStorageItem => ({
  type: ActionsEnum.SET_LOCAL_STORAGE_ITEM,
  payload: {
    key,
    value,
  },
});

export const removeLocalStorageItem = (
  key: string
): RemoveLocalStorageItem => ({
  type: ActionsEnum.REMOVE_LOCAL_STORAGE_ITEM,
  payload: {
    key,
  },
});

export const online = (): Online => ({
  type: ActionsEnum.ONLINE,
});

export const offline = (): Offline => ({
  type: ActionsEnum.OFFLINE,
});

export const tabVisible = (): TabVisible => ({
  type: ActionsEnum.TAB_VISIBLE,
});

export const tabHidden = (): TabHidden => ({
  type: ActionsEnum.TAB_HIDDEN,
});
